//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'StockKittingToolAmountExceededIcon',
  props: {
    manager: {
      type: Object,
      required: true
    },
    toolRecord: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      message: 'Превышение свободных остатков на складе'
    }
  },
  methods: {
    onClick: function () {
      this.$d_ask({
        warning: this.message,
        buttons: [
          { key: 'cancel', name: 'Понятно', color: 'green' }
        ]
      })
    }
  }
}
